__turbopack_context__.v({
  "author": "ExperienceVideoCarouselSection-module__5Oulua__author",
  "carousalContainer": "ExperienceVideoCarouselSection-module__5Oulua__carousalContainer",
  "carousalElement": "ExperienceVideoCarouselSection-module__5Oulua__carousalElement",
  "circleBlurBtn": "ExperienceVideoCarouselSection-module__5Oulua__circleBlurBtn",
  "content": "ExperienceVideoCarouselSection-module__5Oulua__content",
  "elementContent": "ExperienceVideoCarouselSection-module__5Oulua__elementContent",
  "embla": "ExperienceVideoCarouselSection-module__5Oulua__embla",
  "emblaContainer": "ExperienceVideoCarouselSection-module__5Oulua__emblaContainer",
  "emblaNext": "ExperienceVideoCarouselSection-module__5Oulua__emblaNext",
  "emblaPrev": "ExperienceVideoCarouselSection-module__5Oulua__emblaPrev",
  "emblaShimmer": "ExperienceVideoCarouselSection-module__5Oulua__emblaShimmer",
  "emblaSlide": "ExperienceVideoCarouselSection-module__5Oulua__emblaSlide",
  "emblaSlideSelected": "ExperienceVideoCarouselSection-module__5Oulua__emblaSlideSelected",
  "message": "ExperienceVideoCarouselSection-module__5Oulua__message",
  "productOverlayButton": "ExperienceVideoCarouselSection-module__5Oulua__productOverlayButton",
  "root": "ExperienceVideoCarouselSection-module__5Oulua__root" + " " + __turbopack_context__.i(92740)["sectionPadding"],
  "testimonial": "ExperienceVideoCarouselSection-module__5Oulua__testimonial",
  "textCarousal": "ExperienceVideoCarouselSection-module__5Oulua__textCarousal",
});
